import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { saveAs } from "file-saver";

@Injectable({
  providedIn: "root",
})
export class MediaService {
  mediaUrl = environment.config.mediaUrl;

  dbt_media = environment.config.dbt_media_api;

  constructor(private http: HttpClient) {}

  uploadFiles(data, params = {}) {
    return this.http.post<any>(this.mediaUrl + "upload/multiple", data, {
      params,
    });
  }
  uploadSingle(data, params = {}) {
    return this.http.post<any>(this.mediaUrl + "upload", data, { params });
  }


  uploadSingleFilesInSubFolders(data, params = {}) {
    return this.http.post<any>(this.mediaUrl + "upload/national", data, { params });
  }

  uploadFilesInSubFolders(data, params = {}) {
    return this.http.post<any>(this.mediaUrl + "upload/national/multiple", data, {
      params,
    });
  }

  // Added By Vinit Jain
  uploadDBTData(data, params = {}) {
    return this.http.post<any>(this.dbt_media, data, { params });
  }

  viewFile(file, service = null) {
    const params = service ? { file, service } : { file };
    this.http
      .get<any>(this.mediaUrl + "upload", { params })
      .subscribe((res) => {
        if (res.data) {
          this.openFile(res.data);
        }
      });
  }

  getFileUrlView(file) {
    return this.http.post<any>(this.mediaUrl + "upload/get", {
      filename: file,
    });
  }

  getFileUrl(data) {
    const params = Object.assign({}, data);
    delete params.file;
    return this.http.post<any>(
      this.mediaUrl + "upload/get",
      { filename: data.file },
      { params }
    );
  }
  //NEW CHNGES FOR GET FILE URL
  getFileUrlNew(data) {
    const params = Object.assign({}, data);
    delete params.file;
    return this.http.post<any>(
      this.mediaUrl + "upload/get/?service=odffa&subfolder=selfie",
      { filename: data.file },
      { params }
    );
  }
  openFile(url) {
    window.open(url, "_blank");
  }
  downloadFile(url) {
    saveAs(url);
  }
}
